/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { OasPaths } from '../../openapi/models/OasPaths';

/**
 * A command used to create a new operation in a path.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewOperationCommand extends AbstractCommand {
    public _path : string;

    public _method : string;

    public _created : boolean;

    public constructor(path? : any, method? : any) {
        if(((typeof path === 'string') || path === null) && ((typeof method === 'string') || method === null)) {
            let __args = arguments;
            super();
            if(this._path===undefined) this._path = null;
            if(this._method===undefined) this._method = null;
            if(this._created===undefined) this._created = false;
            if(this._path===undefined) this._path = null;
            if(this._method===undefined) this._method = null;
            if(this._created===undefined) this._created = false;
            (() => {
                this._path = path;
                this._method = method;
            })();
        } else if(path === undefined && method === undefined) {
            let __args = arguments;
            super();
            if(this._path===undefined) this._path = null;
            if(this._method===undefined) this._method = null;
            if(this._created===undefined) this._created = false;
            if(this._path===undefined) this._path = null;
            if(this._method===undefined) this._method = null;
            if(this._created===undefined) this._created = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewOperationCommand] Executing.");
        let odoc : OasDocument = <OasDocument>document;
        this._created = false;
        if(this.isNullOrUndefined(odoc.paths)) {
            return;
        }
        let path : OasPathItem = odoc.paths.getPathItem(this._path);
        if(this.isNullOrUndefined(path)) {
            return;
        }
        let operation : OasOperation = path.createOperation(this._method);
        NodeCompat.setProperty(path, this._method, operation);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewOperationCommand] Reverting.");
        if(!this._created) {
            return;
        }
        let odoc : OasDocument = <OasDocument>document;
        if(this.isNullOrUndefined(odoc.paths)) {
            return;
        }
        let path : OasPathItem = odoc.paths.getPathItem(this._path);
        if(this.isNullOrUndefined(path)) {
            return;
        }
        NodeCompat.setProperty(path, this._method, null);
    }
}
NewOperationCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewOperationCommand";
NewOperationCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




